import angular from 'angular';

const componentOptions = {
    bindings: {
        footerModel: '<',
        isFullWidth: '<'
    },
    controllerAs: 'bidsFooterCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-bids-footer-view.html';
    }]
};


const componentInfo = {
    module: 'ib-bids-footer-module',
    selector: 'ibBidsFooter',
    inject: ['$scope', 'localStorageService'],
    required: ['']
};

export class ibBidsFooter implements ng.IController {
    public phoneNumber = '';
    public prefix = '';
    public phonesList: any;
    public currentYear: any;
    constructor (
        private $scope: angular.IScope,
        private localStorageService: angular.local.storage.ILocalStorageService) {
    }

    $onInit (): void {
        this.phonesList = this.localStorageService.get('phonesList');
        this.currentYear = new Date().getFullYear();
        if (this.phonesList && this.phonesList.RESERVAS) {
            this.phoneNumber = this.phonesList.RESERVAS.telephone;
            this.prefix = this.phonesList.RESERVAS.prefix;
        }
    }

    updateInfoFooter = (): void => {
        this.phonesList = this.localStorageService.get('phonesList');
        if (this.phonesList && this.phonesList.RESERVAS) {
            this.phoneNumber = this.phonesList.RESERVAS.telephone;
            this.prefix = this.phonesList.RESERVAS.prefix;
        }
    };
}




try {
    const mod = angular.module(componentInfo.module);
    ibBidsFooter.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBidsFooter })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBidsFooter.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBidsFooter })
    );
}